import Links from './Links.vue';

export default Links;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/itemsblock/components/links/index.ts